<div class="shipment-box-expanded-row">
  <div class="shipment-box-expanded-row__summary">
    <div class="shipment-box-expanded-row__block">
      <span class="shipment-box-expanded-row__label">Box Note</span>
      <span class="shipment-box-expanded-row__value">{{ box.note || "-" }}</span>
    </div>
    <div class="shipment-box-expanded-row__block">
      <span class="shipment-box-expanded-row__label">Contents</span>
      <span class="shipment-box-expanded-row__value">
        {{ getPackedLineCount() }} line{{ getPackedLineSuffix() }} packed into this box.
      </span>
    </div>
  </div>

  <div class="shipment-box-expanded-row__metrics">
    <div class="shipment-box-expanded-row__metric">
      <span class="shipment-box-expanded-row__label">Packed Lines</span>
      <strong>{{ getPackedLineCount() }}</strong>
    </div>
    <div class="shipment-box-expanded-row__metric">
      <span class="shipment-box-expanded-row__label">Requests</span>
      <strong>{{ getRequestCount() }}</strong>
    </div>
    <div class="shipment-box-expanded-row__metric">
      <span class="shipment-box-expanded-row__label">Owners</span>
      <strong>{{ getOwnerCount() }}</strong>
    </div>
    <div class="shipment-box-expanded-row__metric">
      <span class="shipment-box-expanded-row__label">Packed Qty</span>
      <strong>{{ getPackedQty() }}</strong>
    </div>
  </div>

  @if (items.length > 0) {
  <div class="shipment-box-expanded-row__items">
    <div class="shipment-box-expanded-row__items-header">
      <span>Request</span>
      <span>Material</span>
      <span>Owner</span>
      <span>Institution</span>
      <span>Qty</span>
    </div>
    @for (item of items; track item.requestId + '-' + item.materialId + '-' + $index) {
    <div class="shipment-box-expanded-row__item-row">
      <span>{{ item.requestNo || "-" }}</span>
      <span>{{ item.materialName || item.materialSku || "-" }}</span>
      <span>{{ item.ownerName || "-" }}</span>
      <span>{{ item.institutionName || "-" }}</span>
      <span>{{ item.qty }}</span>
    </div>
    }
  </div>
  } @else {
  <div class="shipment-box-expanded-row__empty">No packed items have been assigned to this box yet.</div>
  }
</div>
